<template>
  <div class="Comment">
    <div class="commentFirst">
      <el-form :model="commentInfo" :rules="rules" ref="ruleForm" label-width="50px" class="demo-ruleForm">
        <div style="display: flex;" class="commentFrom">
          <el-form-item label="评论" prop="content" style="width: 100%;">
            <el-input type="textarea" v-model="commentInfo.content" :rows="3" placeholder="说点什么吧"></el-input>
          </el-form-item>
        </div>
        <el-form-item style="display: flex; justify-content: end; margin-bottom: 0;">
          <el-button type="primary" @click="submitForm('ruleForm')" :loading=firstButtonLoading>发送</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
style="
        font-size: 20px;
        margin: 20px 5px;
        border-left: 5px solid #006fc2;
        padding-left: 10px;
      ">
      <h4 v-if="commentList && commentList.length > 0">评论列表 ({{ commentList.length }}条)</h4>
      <div v-else> <span>还没有评论，快来发表一条吧～</span></div>
    </div>
    <div v-for="(item, index) in commentList" :key="index" style="border-bottom: 1px solid #e3e3e3;">
      <div style="margin-top: 27px; display: flex;">
        <el-avatar size="large" style="margin: 0 10px; font-size: 18px;"> {{ item.creatorName.charAt(0).toUpperCase() }}</el-avatar>
        <div style="flex: auto; position: relative;">
          <div style="display: inline-block">
            <strong style="font-size: 18px; margin-right: 10px ">{{
              item.creatorName
            }}</strong>
          </div>
          <div class="date">{{ item.content }} </div>
          <div class="time">{{ item.createTime | formatDate }}</div>
          <div class="reply-content">
            <div style="width: calc(100% - 60px);" v-if="recoverID == item.ID">
              <el-form
:model="editCommentInfo"
:rules="editRules"
ref="editruleForm"
label-width="50px"
                class="demo-ruleForm">
                <div
                  style="display: flex; flex-wrap: wrap; margin-top: 10px; background-color: #e3e3e3;padding: 15px 15px 0; border-radius: 5px;">
                  <el-form-item label="评论" prop="content" style="width: 100%;">
                    <el-input type="textarea" v-model="editCommentInfo.content" :rows="3" placeholder="说点什么吧"></el-input>
                  </el-form-item>
                  <el-form-item style="display: flex; justify-content: end; width: 100%;">
                    <el-button type="primary" @click="submitForm('editruleForm')" :loading=buttonLoading round>发送</el-button>
                    <el-button round @click="Cancel(item)">取消</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div style="position: absolute;right: 5px;top: -6px;">
              <el-button v-if="recoverID != item.ID" size="mini" round @click="recover(item)">回复</el-button>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 10px 0 10px 40px" v-for="(ritem, jndex) in item.subComment" :key="jndex">
        <div style="display: flex">
          <el-avatar size="small" style="margin: 0 10px; font-size: 12px;" >
              {{ ritem.creatorName.charAt(0).toUpperCase() }}
          </el-avatar>
          <div style="flex: auto">
            <div style="display: inline-block">
              <strong style="font-size: 16px; margin-right: 10px">{{ ritem.creatorName }}</strong>
            </div>
            <div class="date">@<span style="margin: 0 8px 0 0;">{{ item.creatorName }}:</span> {{
              ritem.content }}</div>
            <div class="time">{{ ritem.createTime | formatDate }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import { createAppComments } from '@/api/app';
export default {
  props: {
    appID: {
      type: String,
      default: ''
    },
    appName: {
      type: String,
      default: ''
    },
    getAppComments: Function,
    commentList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShow: false,
      recoverID: '',
      commentInfo: {
        content: '',
        appID: '',
        content: '',
        parentID: '',
        replyName: ''
      },
      editCommentInfo: {
        content: '',
        appID: '',
        content: '',
        parentID: '',
        replyName: ''
      },
      editRules: {
        content: [
          { required: true, message: '请输入评论', trigger: 'blur' },
          { max: 1024, message: '评论内容不能大于1024个字', trigger: 'blur' }
        ]
      },
      rules: {
        content: [
          { required: true, message: '请输入评论', trigger: 'blur' },
          { max: 1024, message: '评论内容不能大于1024个字', trigger: 'blur' }
        ]
      },
      firstButtonLoading: false,
      buttonLoading: false
    };
  },
  filters: {
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  mounted() {
    this.roleType = this.$store.state.user.roleType;
  },
  methods: {

    submitForm(formName) {
      if (!(this.userInfo && this.userInfo.userID)) {
        this.$confirm('你还未登录，去登录？', '提示', {
          confirmButtonText: '前往',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const path = window.location.href;
          window.sessionStorage.setItem('path', path);
          this.$router.push({
            name: 'login'
          });
        });
      } else {
        if (formName == 'editruleForm') {
          this.$refs[formName][0].validate((valid) => {
            if (valid) {
              this.buttonLoading = false
              const commentInfo = {
                appID: this.appID,
                content: this.editCommentInfo.content,
                parentID: this.editCommentInfo.parentID || 0,
                replyName: this.editCommentInfo.replyName,
                marketID: '859a51f9bb3b48b5bfd222e3bef56425',
                appName: this.appName
              }
              createAppComments(commentInfo).then(res => {
                this.getAppComments()
                this.$message.success('评论成功');
                this.buttonLoading = false
                this.isShow = true
                this.recoverID = ''
                this.editCommentInfo = {
                  content: '',
                  appID: '',
                  content: '',
                  parentID: '',
                  replyName: ''
                }
              })
            }
          });
        } else {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.firstButtonLoading = true
              const commentInfo = {
                appID: this.appID,
                content: this.commentInfo.content,
                parentID: this.commentInfo.parentID || 0,
                replyName: this.commentInfo.replyName,
                marketID: '859a51f9bb3b48b5bfd222e3bef56425',
                appName: this.appName
              }
              createAppComments(commentInfo).then(res => {
                this.getAppComments()
                this.$message.success('评论成功');
                this.firstButtonLoading = false
                this.isShow = true
                this.commentInfo = {
                  content: '',
                  appID: '',
                  content: '',
                  parentID: '',
                  replyName: ''
                }
              })
            }
          });
        }
      }
    },
    recover(item) {
      this.recoverID = item.ID
      this.editCommentInfo.parentID = item.ID
    },
    Cancel(item) {
      this.recoverID = ''
    }

  }

};
</script>

<style lang="scss" scoped>
.Comment {
  color: black;

  .OwO {
    position: relative;
    z-index: 1;

    .OwO-body {
      position: absolute;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 0 4px 4px 4px;

      .OwO-items {
        max-height: 197px;
        overflow-y: scroll;
        padding: 10px;

        .OwO-item {
          background: #f7f7f7;
          padding: 5px 10px;
          border-radius: 5px;
          display: inline-block;
          margin: 0 10px 12px 0;
          transition: 0.3s;
          line-height: 19px;
          font-size: 20px;
          cursor: pointer;

          &:hover {
            background: #eee;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
              0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          }
        }
      }
    }
  }

  .date {
    font-size: 16px;
    color: grey;
    margin: 6px 0;
  }

  .time {
    font-size: 12px;
    color: grey;
    margin: 6px 0;
  }

  .deleteComment {
    font-size: 14px;
    color: rgb(109, 88, 88);
    cursor: pointer;
  }

  .reply-content {}
}

.commentFirst {
  background-color: #fafafa;
  padding: 24px;
  border-radius: 5px;
  -webkit-box-shadow: 0 1px 3px rgba(18, 18, 18, 0.3);
  box-shadow: 0 1px 3px rgba(18, 18, 18, 0.3);

  .commentFrom {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/appstore/components/commit.vue